import React, { useContext, useEffect, useState } from "react";
import AdminContext from "../../../admin/StateContext/Application";
import ReactApexChart from "react-apexcharts";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./page.css";
import Select from "react-select";

import {
  Approved32,
  Click32,
  Disable32,
  Earnings,
  Earningss,
  Earningsss,
  Error32,
  fifth,
  first,
  forth,
  Graph64,
  MoreMenu64,
  NewTasks64,
  Sales,
  Second,
  Spendthismonth64,
  third,
  TotalProjects64,
  Unclick32,
  YourBalance,
} from "../../../../public/LoginImages/importimages";
import "../../../Users/pages/innercss.css";

// 28-10 change the UI 
const ArrowIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="4"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 12h16M13 5l7 7-7 7" />
  </svg>
);
const svgProps = {
  width: 18, height: 18, viewBox: "0 0 24 24", fill: "none",
  stroke: "#fff", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round",
};

const Icons = {
  // Demand Against Liability: document with lines
  demand: (
    <svg {...svgProps}>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
      <path d="M14 3v5h5M9 13h6M9 17h6" />
    </svg>
  ),
  // Total Liability: scroll / ledger
  liability: (
    <svg {...svgProps}>
      <rect x="5" y="3" width="14" height="18" rx="2" />
      <path d="M9 8h6M9 12h6M9 16h3" />
    </svg>
  ),
  // Available Balance: bank building
  bank: (
    <svg {...svgProps}>
      <path d="M3 10l9-6 9 6" />
      <path d="M5 10v8M9.5 10v8M14.5 10v8M19 10v8M3 21h18" />
    </svg>
  ),
  // Excess / Shortfall: rupee
  rupee: (
    <svg {...svgProps}>
      <path d="M7 5h10M7 9h10M7 5c5 0 7 2 7 4s-2 4-7 4l7 6" />
    </svg>
  ),
};
// 03-11 onclick on cards
const MetricCard = ({
  theme, icon, label, value, valueColor, percent = 0,
  onClick, disabled, hideArrow = false,
}) => {
  const clickable = !!onClick && !disabled;

  return (
    <div
      className={`pd-metric pd-${theme}`}
      onClick={clickable ? onClick : undefined}
      style={{
        cursor: clickable ? "pointer" : "default",
        opacity: disabled ? 0.6 : 1,
      }}
    >
      {!hideArrow && (
        <div className="pd-metric-arrow">
          <ArrowIcon />
        </div>
      )}

      <div
        className="pd-metric-icon"
        style={{ background: "transparent", boxShadow: "none", border: "none" }}
      >
        {icon}
      </div>

      <div className="pd-metric-label">{label}</div>
      <div className="pd-metric-value" style={valueColor ? { color: valueColor } : undefined}>
        {value}
      </div>
      <div className="pd-metric-bar">
        <span style={{ width: `${Math.max(0, Math.min(100, percent))}%` }} />
      </div>
    </div>
  );
};


const buildPages = (current, total) => {
  if (total <= 5) return Array.from({ length: total }, (_, i) => i + 1);
  if (current <= 3) return [1, 2, 3, 4, 5, "...", total];
  if (current >= total - 2) return ["...", total - 4, total - 3, total - 2, total - 1, total];
  return ["...", current - 1, current, current + 1, "...", total];
};

const PdPagination = ({ page, totalPages, setPage, from, to, total }) => (
  <div className="pd-pagination">
    <p className="pd-showing">
      Showing {total === 0 ? 0 : from} to {to} of {total} entries
    </p>
    <div className="pd-pages pd-pages-text">
      <button className="pd-nav" disabled={page === 1}
              onClick={() => setPage((p) => Math.max(p - 1, 1))}>
        <span className="pd-chev">‹</span> Previous
      </button>

      {buildPages(page, totalPages).map((n, i) =>
        n === "..." ? (
          <span key={`d${i}`} className="pd-dots">...</span>
        ) : (
          <button key={n} className={page === n ? "pd-num active" : "pd-num"}
                  onClick={() => setPage(n)}>{n}</button>
        )
      )}

      <button className="pd-nav" disabled={page === totalPages || totalPages === 0}
              onClick={() => setPage((p) => Math.min(p + 1, totalPages))}>
        Next <span className="pd-chev">›</span>
      </button>
    </div>
  </div>
);
// ------------------------
const ProjectDashboard = () => {
  const content = useContext(AdminContext);
  const {
    GetTaxAmounts,
    GetVendorBills,
    getTaxAmountsByDate,
    GetDateWiseData,
    GetProjectTotal,
    GetTotalAmountAvailbaleInBank,
    GetLiabilityTotal,
    GetProjectInfo,
  } = content;

  const sortLatestFirst = (list) => {
    if (!Array.isArray(list)) return [];

    return [...list].sort((a, b) => {
      const dateA = new Date(a.Date || 0).getTime();
      const dateB = new Date(b.Date || 0).getTime();

      return dateB - dateA;
    });
  };
  //4/9/2026
  const [getData, SetData] = useState({});
  const [vendorbills, setVendorBills] = useState([]);
  const [taxesData, SetTaxesData] = useState({});
  const [loading, setloading] = useState(true);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [dateData, setDateData] = useState([]);
  const [projectdata, setProjectData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [liabilityData, setLiabilityData] = useState([]);
  const [BankBalance, setBankBalance] = useState([]);
  const [demandList, setDemandList] = useState();
  const [showspecific, setSpecific] = useState(0);
  const [availabeBalancinBank, setAvailabeBalancinBank] = useState([]);
  const [CountBalance, setCountBalance] = useState([]);
  const [projectSearchTerm, setProjectSearchTerm] = useState("");
  const [liabilitySearchTerm, setLiabilitySearchTerm] = useState("");
  const [demandSearchTerm, setDemandSearchTerm] = useState("");
  const [bankSearchTerm, setBankSearchTerm] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [liabilityPage, setLiabilityPage] = useState(1);
  const [bankPage, setBankPage] = useState(1);
  const itemsPerPage = 5; // show 5 rows per page
  const [demandList1, setDemandList1] = useState();
  const [scheme, setScheme] = useState("");
  const [demandPage, setDemandPage] = useState(1);
  const [data, setData] = useState({
    ProjectName: "",
    ProjectID: "",
    PIU: "",
    AvaiableReleaseAmount: 0,
    SelectedDemandAmount: 0,
    Balance: 0,
  });


  // 04-11 for search input clear
  const handleBackToDashboard = ()=>{
    setSpecific(0);
    setDemandSearchTerm("");
    setLiabilitySearchTerm("");
    setBankSearchTerm("");

    setDemandPage(1);
    setLiabilityData(1);
    setBankPage(1);
  }
  // Filtered data for Project Details Table
  const filteredProjectData = tableData.filter((project) =>
    Object.values(project)
      .join(" ")
      .toLowerCase()
      .includes(projectSearchTerm.toLowerCase()),
  );
  console.log("filteredProjectData", filteredProjectData);

  const searchedProjects = tableData.filter((project) => {
    const search = projectSearchTerm.toLowerCase().trim();

    return (
      project.ProjectName?.toLowerCase().includes(search) ||
      project.PIU?.toLowerCase().includes(search) ||
      project.ProjectID?.toString().includes(search)
    );
  });
  const filteredProjects = searchedProjects.filter((project) => {
    if (scheme === "") return true;
    return (
      project.Scheme &&
      project.Scheme.trim().toLowerCase() === scheme.trim().toLowerCase()
    );
  });
  useEffect(() => {
    setCurrentPage(1);
  }, [projectSearchTerm, scheme]);
  // Calculate data for current page

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentTableData = filteredProjects.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );

  // Total pages
  const totalPages = Math.ceil(filteredProjects.length / itemsPerPage);

  // Change page
  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const filteredLiabilityData = Array.isArray(demandList) ? demandList : [];
  const filteredLiabilityData1 = Array.isArray(demandList1) ? demandList1 : [];

  const searchedLiabilityData = filteredLiabilityData1.filter((item) => {
    const search = liabilitySearchTerm.toLowerCase().trim();
    // const search = demandSearchTerm.toLowerCase().trim();

    return (
      item.ProjectName?.toLowerCase().includes(search) ||
      item.PIU?.toLowerCase().includes(search) ||
      item.ProjectID?.toString().includes(search)
    );
  });

  //--add new pagination
  const getProjectPageNumbers = () => {
    const maxVisiblePages = 5;
    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }
    let startPage = currentPage - 2;
    let endPage = currentPage + 2;
    if (currentPage <= 3) {
      startPage = 1;
      endPage = 5;
    }
    if (currentPage >= totalPages - 2) {
      startPage = totalPages - 4;
      endPage = totalPages;
    }
    return Array.from(
      { length: endPage - startPage + 1 },
      (_, index) => startPage + index,
    );
  };

  

  // Pagination logic for Liability

  const liabilityDataForScheme = (() => {
    // ==========================================
    // 1. NO SCHEME SELECTED
    // ==========================================
    if (!scheme) {
      const uniqueProjects = [];

      const projectIds = new Set();

      searchedLiabilityData.forEach((item) => {
        const projectId = item.ProjectID ?? item.ProjectId;

        if (!projectIds.has(projectId)) {
          projectIds.add(projectId);
          uniqueProjects.push(item);
        }
      });

      return uniqueProjects;
    }

    // ==========================================
    // 2. NON-BUDGET SELECTED
    // ==========================================
    if (scheme.toLowerCase() === "nonbudget") {
      const nonBudgetData = searchedLiabilityData.filter(
        (item) =>
          String(item.Scheme || "")
            .trim()
            .toLowerCase() === "nonbudget",
      );

      const uniqueProjects = [];
      const projectIds = new Set();

      nonBudgetData.forEach((item) => {
        const projectId = item.ProjectID ?? item.ProjectId;

        if (!projectIds.has(projectId)) {
          projectIds.add(projectId);
          uniqueProjects.push(item);
        }
      });

      return uniqueProjects;
    }

    // ==========================================
    // 3. BUDGET SELECTED
    // ==========================================
    if (scheme.toLowerCase() === "budget") {
      return searchedLiabilityData.filter(
        (item) =>
          String(item.Scheme || "")
            .trim()
            .toLowerCase() === "budget",
      );
    }

    return [];
  })();
  const liabilityTotalPages = Math.ceil(
    liabilityDataForScheme.length / itemsPerPage,
  );
  const liabilityIndexOfLastItem = liabilityPage * itemsPerPage;
  const liabilityIndexOfFirstItem = liabilityIndexOfLastItem - itemsPerPage;
  const liabilityTableData = liabilityDataForScheme.slice(
    liabilityIndexOfFirstItem,
    liabilityIndexOfLastItem,
  );

  useEffect(() => {
    setLiabilityPage(1);
  }, [liabilitySearchTerm, scheme]);

  // Filtered data for Bank Table
  const filteredBankData = (availabeBalancinBank || []).filter((item) =>
    Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(bankSearchTerm.toLowerCase()),
  );

  // Pagination for Bank
  const bankTotalPages = Math.ceil(filteredBankData.length / itemsPerPage);
    const bankIndexOfLastItem = bankPage * itemsPerPage;   // was currentPage 28-10
  const bankIndexOfFirstItem = bankIndexOfLastItem - itemsPerPage;
  const bankTableData = filteredBankData.slice(
    bankIndexOfFirstItem,
    bankIndexOfLastItem,
  );
    // 28-10
useEffect(() => {
  setBankPage(1);
}, [bankSearchTerm]);


  const liabilityAmount =
    scheme === "Budget"
      ? liabilityData.Budget_Liability
      : scheme === "NonBudget"
        ? liabilityData.NonBudget_Liability
        : liabilityData.LiabalityAmount;
  const projectCost =
    scheme === "Budget"
      ? projectdata?.Budget_Project_Cost
      : scheme === "NonBudget"
        ? projectdata?.NonBudget_Project_Cost
        : projectdata?.Project_Cost;

  console.log("liabilityAmount", liabilityAmount);
  console.log("projectCost", projectCost);
  console.log("liabilityData", liabilityData);
  console.log("projectdata", projectdata);
  useEffect(() => {
    GetAmountOfTaxes();
    getVendorbill();
    getTaxesAmountbyDate();
    GetAllProjectTotal();
    GetTotalAmountAvailableInBank();
    GetLiabilityTotalAmount();
    GetProjectCostAmount();
  }, []);
  const GetProjectCostAmount = async () => {
    let data = await GetLiabilityTotal("Project");

    console.log("Project API:", data);

    setProjectData(data[0]);
  };
  const GetAmountOfTaxes = async () => {
    let data = await GetTaxAmounts();
    console.log(data);
    SetData((prevState) => {
      return data;
    });
    setloading(false);
  };

  const GetAllProjectTotal = async () => {
    let data = await GetProjectTotal();
    console.log("projectdataaaaa", data);
    setProjectData(data);
    setTableData(data);
    // setloading(false);
  };

  const TotalAmount = () => {
    const totalAvaiablereleaseAmount = tableData.reduce(
      (acc, item) => acc + Number(item.EsitmateAmount),
      0,
    );

    setData((prev) => ({
      ...prev,
      AvaiableReleaseAmount: totalAvaiablereleaseAmount,
    }));
  };

  useEffect(() => {
    TotalAmount();
  }, [tableData]);

  const getVendorbill = async () => {
    let data1 = await GetVendorBills();
    setVendorBills(data1);
    // setloading(false);
  };
  let vendorBillList = [];
  if (vendorbills.length > 0) {
    vendorBillList = vendorbills;
  }

 

   // 29-09 state wise data

const GetTotalAmountAvailableInBank = async () => {
  try {
    const data = await GetTotalAmountAvailbaleInBank();

    console.log("Bank API response:", data);

    setBankBalance(data?.result?.[0] || { AvailableBalanceinBank: 0 });
    setCountBalance(data?.result1?.[0] || { SendAmountToVender: 0 });
  } catch (error) {
    console.error("GetTotalAmountAvailableInBank error:", error);

    setBankBalance({ AvailableBalanceinBank: 0 });
    setCountBalance({ SendAmountToVender: 0 });
  }
};

  let TotalPaidCount =
    BankBalance.AvailableBalanceinBank - CountBalance.SendAmountToVender;
  console.log("BankBalance", BankBalance);

  const GetLiabilityTotalAmount = async () => {
    let data = await GetLiabilityTotal("Liability");
    console.log("GetLiabilityTotal--->", data);
    setLiabilityData(data[0]);
  };
  const getTaxesAmountbyDate = async () => {
    let data = await getTaxAmountsByDate();
    console.log(data);
  };
  const sidepanel = () => {
    setIsSidebarOpen(!isSidebarOpen); // toggle sidebar
  };

// 29-09 state wise data
const FetchDemandList = async () => {
  try {
    const res = await GetProjectInfo("", "");
    const res1 = await GetProjectInfo("", "avaiableInBank");
    const res2 = await GetProjectInfo("", "totalLiability");

    console.log("Demand API:", res);
    console.log("Available Bank API:", res1);
    console.log("Liability API:", res2);

    // Keep existing live sorting
    const sortedDemandList = sortLatestFirst(
      Array.isArray(res) ? res : []
    );

    const sortedBankList = sortLatestFirst(
      Array.isArray(res1) ? res1 : []
    );

    const sortedLiabilityList = sortLatestFirst(
      Array.isArray(res2) ? res2 : []
    );

    setDemandList(sortedDemandList);
    setDemandList1(sortedLiabilityList);
    setAvailabeBalancinBank(sortedBankList);

  } catch (err) {
    console.error("FetchDemandList error:", err);

    setDemandList([]);
    setDemandList1([]);
    setAvailabeBalancinBank([]);
  }
};
  useEffect(() => {
    FetchDemandList();
  }, []);

  const getPageNumbers = (currentPage, totalPages) => {
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    // Page 1, 2, 3
    if (currentPage <= 3) {
      return [1, 2, 3, 4, 5, "...", totalPages];
    }

    // Last 3 pages
    if (currentPage >= totalPages - 2) {
      return [
        "...",
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }

    // Middle pages
    return [
      "...",
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
      "...",
      totalPages,
    ];
  };
  const demandItemsPerPage = 5;

  const filteredDemandData = (demandList || []).filter((item) =>
    Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(demandSearchTerm.toLowerCase()),
  );

  const demandDataForScheme = filteredDemandData.filter((item) => {
    if (!scheme) return true;

    return (
      item.Scheme &&
      item.Scheme.trim().toLowerCase() === scheme.trim().toLowerCase()
    );
  });

  const demandTotalPages = Math.ceil(
    demandDataForScheme.length / demandItemsPerPage,
  );

  const demandIndexOfLastItem = demandPage * demandItemsPerPage;

  const demandIndexOfFirstItem = demandIndexOfLastItem - demandItemsPerPage;

  const demandTableData = demandDataForScheme.slice(
    demandIndexOfFirstItem,
    demandIndexOfLastItem,
  );

  useEffect(() => {
    setDemandPage(1);
  }, [demandSearchTerm, scheme]);


  
  // 28-10 for UI change
  const pct = (a, b) => (Number(b) > 0 ? (Number(a) / Number(b)) * 100 : 0);
const bankAmt = Number(BankBalance.AvailableBalanceinBank || 0);
const liabAmt = Number(liabilityAmount || 0);
const costAmt = Number(projectCost || 0);
// const excess = bankAmt - liabAmt; // image shows the minus sign, so no Math.abs
// after: no minus sign
const excess = Math.abs(bankAmt - liabAmt);
  return (
    <>
      <div
        style={{
          background: "#ffffff",
          width: "auto",
          maxHeight: "90vh",
          transition: "margin-left 0.3s ease",
          overflowY: "auto",
          msOverflowStyle: "none", // IE & Edge
          scrollbarWidth: "none",
          padding: 20,
          fontFamily: "Inter, sans-serif",
        }}
        className="no-scrollbar"
      >
       
        {/* --- Default Dashboard -- 28-10- */}
      {showspecific === 0 && (
  <div className="dashboard-page pd-page">
  

    {/* Scheme bar */}
    <div className="pd-scheme-bar">
      <label className="pd-scheme-label">Scheme Name :</label>
      <div className="pd-scheme-select">
        <Select
          options={[
            { value: "Budget", label: "Budget" },
            { value: "NonBudget", label: "Non Budget" },
          ]}
          value={
            scheme
              ? { value: scheme, label: scheme === "NonBudget" ? "Non Budget" : "Budget" }
              : null
          }
          // onChange={(o) => setScheme(o ? o.value : "")}
          // 04-11 for search input clear 
          onChange ={(o)=>{
            setScheme(o ? o.value :"");
            setProjectSearchTerm("");
            setCurrentPage(1);
          }}
          placeholder="Choose Scheme"
          isSearchable
          isClearable
          classNamePrefix="scheme"
        />
      </div>
    </div>

 {/* Project Overview */}
    <div className="pd-card">
      <div className="pd-card-title">Project Overview</div>
      <div className="pd-metrics">
        
        <MetricCard
          theme="blue"
          // icon="/ProjectDashboard-Demand-Against-Liabilitys.png"
          // icon={Icons.demand}
          icon={
    <img
      src="/Demand-Against-Liability-64.png"
      alt="Demand Against Liability"
      style={{ width: 44, height: 44, objectFit: "contain" }}
    />
  }
          label="Demand Against Liability"
          value={`₹ ${liabAmt.toLocaleString("en-IN")}`}
          percent={pct(liabAmt, costAmt)}
          disabled={liabAmt <= 0}
          onClick={() => setSpecific(1)}
        />
        
        <MetricCard
          theme="purple"
        // icon={Icons.liability}
          icon={
    <img
      src="/Total-Liability64.png"
      alt="Total Liability"
      style={{ width: 44, height: 44, objectFit: "contain" }}
    />
  }
          label="Total Liability"
          value={`₹ ${costAmt.toLocaleString("en-IN")}`}
          percent={100}
          onClick={() => setSpecific(1.1)}
        />
        <MetricCard
          theme="green"
        //  icon={Icons.bank}
          icon={
    <img
      src="/Available-Balance-32.png"
      alt="Available Balance"
      style={{ width: 44, height: 44, objectFit: "contain" }}
    />
  }
          label="Available Balance"
          value={`₹ ${bankAmt.toLocaleString("en-IN")}`}
          percent={pct(bankAmt, liabAmt)}
          onClick={() => setSpecific(2)}
        />
        
        <MetricCard
          theme="orange"
        //  icon={Icons.rupee}
          icon={
    <img
      src="/Excess%2C-Shortfall-64.png"
      alt="Excess Shortfall"
      style={{ width: 44, height: 44, objectFit: "contain" }}
    />
  }
          label="Excess/ Shortfall"
          value={excess.toLocaleString("en-IN")}
          percent={Math.abs(pct(excess, liabAmt))}
            hideArrow
        />
      </div>
    </div>

    {/* Project Details */}
    <div className="pd-card">
      <div className="pd-details-panel">
        <div className="pd-details-header">
          <div className="pd-details-title">
            <img src={"/List-32.png"} alt="" />
            <span>Project Details</span>
          </div>
          <div className="pd-search">
            <img src={"/Search-32.png"} alt="" />
            <input
              type="text"
              placeholder="Search Here.."
              value={projectSearchTerm}
              onChange={(e) => setProjectSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className="pd-table-card">
          <div className="pd-table-scroll">
            <table className="pd-table" style={{borderRadius:"4px"}}>
              <thead>
                <tr>
                  <th style={{ width: 60 }}>Sr.No</th>
                  <th>Project Name</th>
                  <th>Implementing Agency</th>
                  <th>Approved Project Cost</th>
                  {scheme !== "Budget" && scheme !== "" && <th>Limit Allocation</th>}
                  <th>Demand Received</th>
                  {scheme !== "NonBudget" && scheme !== "" && <th>Estimation Amount</th>}
                  <th>Balance</th>
                </tr>
              </thead>
              <tbody>
                {currentTableData.length ? (
                  currentTableData.map((project, index) => {
                    const balance =
                      (scheme === "Budget"
                        ? Number(project.EsitmateAmount || 0)
                        : Number(project.ReleaseAmount || 0)) -
                      Number(project.BillAmount || 0);
                    return (
                      <tr key={index}>
                        <td className="c">{indexOfFirstItem + index + 1}</td>
                        <td className="l">{project.ProjectName}</td>
                        <td className="c" style={{color:"blue"}}>{project.PIU}</td>
                        <td className="l pd-cost">
                          <img src={Approved32} alt="" />
                          {Number(project.ProjectCost || 0).toLocaleString("en-IN")}
                        </td>
                        {scheme !== "Budget" && scheme !== "" && (
                          <td className="r">
                            {Number(project.ReleaseAmount || 0).toLocaleString("en-IN")}
                          </td>
                        )}
                        <td className="r pd-green">
                          {Number(project.BillAmount || 0).toLocaleString("en-IN")}
                        </td>
                        {scheme !== "NonBudget" && scheme !== "" && (
                          <td className="r">
                            {Number(project.EsitmateAmount || 0).toLocaleString("en-IN")}
                          </td>
                        )}
                        <td className="r pd-blue">{balance.toLocaleString("en-IN")}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="8" className="c">No Project Found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="pd-pagination">
            <p className="pd-showing">
              Showing {filteredProjects.length === 0 ? 0 : indexOfFirstItem + 1} to{" "}
              {Math.min(indexOfLastItem, filteredProjects.length)} of {filteredProjects.length} entries
            </p>
            <div className="pd-pages pd-pages-text">
  <button
    className="pd-nav"
    disabled={currentPage === 1}
    onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
  >
    <span className="pd-chev">‹</span> Previous
  </button>

  {getProjectPageNumbers().map((n) => (
    <button
      key={n}
      className={currentPage === n ? "pd-num active" : "pd-num"}
      onClick={() => setCurrentPage(n)}
    >
      {n}
    </button>
  ))}

  <button
    className="pd-nav"
    disabled={currentPage === totalPages || totalPages === 0}
    onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
  >
    Next <span className="pd-chev">›</span>
  </button>
</div>
          </div>
        </div>
      </div>
    </div>
  </div>
)}

       {showspecific === 1 && (
      <div className="pd-details-panel">
        <div className="pd-details-header">
          <div className="pd-details-title">
            <button className="pd-back" onClick={handleBackToDashboard}>
              <img src={"/Back-Arrow-32.jpg"} alt="Back" />
            </button>
            <span>Demand Against Liability Details</span>
          </div>
          <div className="pd-search">
            <img src={"/Search-32.png"} alt="" />
            <input
              type="text"
              placeholder="Search Here.."
              value={demandSearchTerm}
              onChange={(e) => setDemandSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className="pd-table-card">
          <div className="pd-table-scroll">
            <table className="pd-table pd-wide" style={{borderRadius:"4px"}}>
              <thead>
                <tr>
                  <th style={{ width: 60 }}>Sr.No</th>
                  <th>Demand ID</th>
                  <th>Project Name</th>
                  <th>Bill Amount</th>
                  <th>Payable Amount</th>
                  <th>Deduction Amount</th>
                  <th>Additional Amount</th>
                  <th>Total Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {demandTableData.map((val, index) => (
                  <tr key={index}>
                    <td className="c">{demandIndexOfFirstItem + index + 1}</td>
                    <td className="c pd-link" style={{color:"blue"}}>{val.DemandGenerationID}</td>
                    <td className="l">{val.ProjectName}</td>
                    <td className="r">{Number(val.BillAmount || 0).toLocaleString("en-IN")}</td>
                    <td className="r">{Number(val.NetPayableAmount || 0).toLocaleString("en-IN")}</td>
                    <td className="r pd-red">{Number(val.DeductionAmount || 0).toLocaleString("en-IN")}</td>
                    <td className="r pd-red">
                      {(Number(val.BillAmount || 0) * 0.01).toLocaleString("en-IN", {
                        minimumFractionDigits: 2, maximumFractionDigits: 2,
                      })}
                    </td>
                    <td className="r pd-red">
                      {(Number(val.BillAmount || 0) * 1.01).toLocaleString("en-IN", {
                        minimumFractionDigits: 2, maximumFractionDigits: 2,
                      })}
                    </td>
                    <td className="c">
                      {val.Approval5 === "true" && val.Approval4 === "true" ? (
                        <span className="pd-badge approved">Approved</span>
                      ) : (
                        <span className="pd-badge pending">Pending</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {!demandTableData.length && <div className="pd-empty">No Project Found</div>}
          </div>

          <PdPagination
            page={demandPage}
            totalPages={demandTotalPages}
            setPage={setDemandPage}
            from={demandIndexOfFirstItem + 1}
            to={Math.min(demandIndexOfLastItem, demandDataForScheme.length)}
            total={demandDataForScheme.length}
          />
        </div>
      </div>
  
)}

           {showspecific === 1.1 && (
      <div className="pd-details-panel">
        <div className="pd-details-header">
          <div className="pd-details-title">
            <button className="pd-back" onClick={handleBackToDashboard}>
              <img src={"/Back-Arrow-32.jpg"} alt="Back" />
            </button>
            <span>Liability Details</span>
          </div>
          <div className="pd-search">
            <img src={"/Search-32.png"} alt="" />
            <input
              type="text"
              placeholder="Search Here.."
              value={liabilitySearchTerm}
              onChange={(e) => setLiabilitySearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className="pd-table-card">
          <div className="pd-table-scroll">
            <table className="pd-table" style={{borderRadius:"4px"}}>
              <thead>
                <tr>
                  <th style={{ width: 60 }}>Sr.No</th>
                  <th style={{ width: 110 }}>Project ID</th>
                  <th>Project Name</th>
                  {scheme === "Budget" && (
                    <>
                      <th>Budget Head</th>
                      <th>Estimate Amount</th>
                    </>
                  )}
                  <th>Project Cost</th>
                </tr>
              </thead>
              <tbody>
                {liabilityTableData.map((val, index) => (
                  <tr key={index}>
                    <td className="c">{liabilityIndexOfFirstItem + index + 1}</td>
                    <td className="c pd-link" style={{color:"blue"}}>{val.ProjectId ?? val.ProjectID}</td>
                    <td className="l">{val.ProjectName}</td>
                    {scheme === "Budget" && (
                      <>
                        <td className="l">{val.HeadName}</td>
                        <td className="r">{Number(val.EsitmateAmount || 0).toLocaleString("en-IN")}</td>
                      </>
                    )}
                    <td className="r pd-blue">{Number(val.ProjectCost || 0).toLocaleString("en-IN")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {!liabilityTableData.length && <div className="pd-empty">No Project found</div>}
          </div>

          <PdPagination
            page={liabilityPage}
            totalPages={liabilityTotalPages}
            setPage={setLiabilityPage}
            from={liabilityIndexOfFirstItem + 1}
            to={Math.min(liabilityIndexOfLastItem, liabilityDataForScheme.length)}
            total={liabilityDataForScheme.length}
          />
        </div>
      </div>
)}
            {/* --- Available Balance in Bank - 28-10-- */}
       {showspecific === 2 && (
      <div className="pd-details-panel">
        <div className="pd-details-header">
          <div className="pd-details-title">
            <button className="pd-back" onClick={handleBackToDashboard}>
              <img src={"/Back-Arrow-32.jpg"} alt="Back" />
            </button>
            <span>Available Balance</span>
          </div>
          <div className="pd-search">
            <img src={"/Search-32.png"} alt="" />
            <input
              type="text"
              placeholder="Search Here.."
              value={bankSearchTerm}
              onChange={(e) => setBankSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className="pd-table-card">
          <div className="pd-table-scroll">
            <table className="pd-table pd-wide" style={{borderRadius:"4px"}}>
              <thead>
                <tr>
                  <th style={{ width: 60 }}>Sr.No</th>
                  <th style={{ width: 90 }}>Year</th>
                  <th>GR Number</th>
                  <th>Letter Number</th>
                  <th>UTR Number</th>
                  <th>Fund Amount</th>
                  <th>Remaining Amount</th>
                </tr>
              </thead>
              <tbody>
                {bankTableData.map((val, index) => (
                  <tr key={index}>
                    <td className="c">{bankIndexOfFirstItem + index + 1}</td>
                    <td className="c">{val.Year}</td>
                    <td className="c">{val.GRNumber}</td>
                    <td className="c">{val.LetterNumber}</td>
                    <td className="c">{val.UTRNumber}</td>
                    <td className="r pd-green">{Number(val.FundAmount || 0).toLocaleString("en-IN")}</td>
                    <td className="r pd-blue">{Number(val.RemainingFundAmount || 0).toLocaleString("en-IN")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {!bankTableData.length && <div className="pd-empty">No Bank Data Found</div>}
          </div>

          <PdPagination
            page={bankPage}
            totalPages={bankTotalPages}
            setPage={setBankPage}
            from={bankIndexOfFirstItem + 1}
            to={Math.min(bankIndexOfLastItem, filteredBankData.length)}
            total={filteredBankData.length}
          />
        </div>
      </div>
)}
      </div>
    </>
  );

  
};

export default ProjectDashboard;
